import { cn } from "../../lib/utils";

const BAR_HEIGHTS = [
  "h-[40%]",
  "h-[70%]",
  "h-[50%]",
  "h-[90%]",
  "h-[55%]",
  "h-[80%]",
  "h-[35%]",
  "h-[65%]",
  "h-[45%]",
  "h-[75%]",
];

export const BarChartBackdrop = () => (
  <div className="flex h-full w-full items-end gap-1 p-4">
    {BAR_HEIGHTS.map((height) => (
      <div key={height} className={cn("flex-1 rounded-sm bg-foreground/20", height)} />
    ))}
  </div>
);
